import { type } from "jquery";

// Risk Head — the company-side signer on TA limit setting documents.
export const risk_head_role = "Sachin Kaware";

export const docArray = [
  { id: "aadhar_front", label: "Aadhar Card Front" },
  { id: "aadhar_back", label: "Aadhar Card Back" },
  { id: "pan", label: "Pan Card" },
  { id: "firm_pan", label: "Firm PAN" },
  { id: "passport_photo", label: "Passport Size Photo" },
  { id: "business_proof_1", label: "Bussiness Proof 1" },
  { id: "business_proof_2", label: "Bussiness Proof 2" },
  { id: "ksos_cheque_1", label: "KSOS Cheques 1" },
  { id: "ksos_cheque_2", label: "KSOS Cheques 2" },
  { id: "tyger_cheque_1", label: "Tyger Cheques 1" },
  { id: "tyger_cheque_2", label: "Tyger Cheques 2" },
  { id: "bank_statement", label: "bank Statement" },
  { id: "itr_year_1", label: "ITR 1" },
  { id: "itr_year_2", label: "ITR 1" },
  { id: "partnership_deed", label: "Partnership Deed" },
];

export const bussArray = [
  {
    id: "businessType",
    label: "Business Type",
    type: "select",
    options: [
      "Individual",
      "Proprietor",
      "Partnership",
      "Private limited (Pvt Ltd)",
    ],
    required: true,
    placeholder: "Select business type",
  },
  {
    id: "companyName",
    label: "Business Name",
    placeholder: "Enter business name",
    required: true,
  },

  {
    id: "email",
    label: "Mail ID",
    type: "email",
    placeholder: "Enter email address",
    required: true,
  },
  {
    id: "firmPan",
    label: "Firm Pan",
    placeholder: "Enter Firm PAN",
    required: true,
  },
  {
    id: "userPan",
    label: "Pan Card",
    placeholder: "Enter PAN",
    required: true,
  },
  {
    id: "taUserPhone",
    label: "Contact Number",
    type: "number",
    disabled: true,
    placeholder: "Auto-filled contact number",
  },
  {
    id: "noOfPartners",
    label: "Total Partners",
    type: "number",
    placeholder: "Enter number of partners",
    disabled: false,
    required: true,
  },

  {
    id: "maritalStatusOfApplicant",
    label: "Marital Status of Applicant",
    type: "select",
    options: ["Single", "Married", "Divorced", "Widowed"],
    placeholder: "Select marital status",
    required: true,
  },
  {
    id: "companyAddress",
    label: "Business Address",
    type: "textarea",
    placeholder: "Enter business address",
    required: true,
  },

  {
    id: "residenceType",
    label: "Residence Type",
    type: "select",
    options: ["Owned", "Rented"],
    placeholder: "Select residence type",
    required: true,
  },
  {
    id: "officeType",
    label: "Office Type",
    type: "select",
    options: ["Rented", "Owned"],
    placeholder: "Select office type",
    required: true,
  },

  {
    id: "businessExperienceYears",
    label: "Total Business Experience (in years)",
    placeholder: "Enter business experience in years",
    required: true,
    type: "number",
  },
  {
    id: "vintageWithMeratractorYears",
    label: "Vintage With MeraTractor (in years)",
    placeholder: "Enter years with MeraTractor",
    required: true,
    type: "number",
  },
  {
    id: "monthlyAverageSalesUnit",
    label: "Monthly Average Sales (units)",
    placeholder: "Enter average sales in units",
    required: true,
    type: "number",
  },
  {
    id: "monthlyAverageSalesVolume",
    label: "Monthly Average Sales (volume)",
    placeholder: "Enter average sales volume",
    required: true,
    type: "text",
  },
  {
    id: "dealingInList",
    label: "Dealing In (Vehicle)",
    type: "select",
    options: ["CV", "Tractor", "2 Wheeler"],
    isMulti: true,
    placeholder: "Select vehicle type(s)",
    required: true,
  },

  {
    id: "residentialStabilityYears",
    label: "Residential Stability In Years",
    placeholder: "Enter residential stability in years",
    required: true,
    type: "number",
  },
  {
    id: "yardForStocking",
    label: "Yard For Stocking The Vehicle",
    type: "select",
    options: ["Owned", "Rented"],
    placeholder: "Select yard type",
    required: true,
  },
  {
    id: "yardDetails",
    label: "Details Of Yard Associated With",
    placeholder: "Enter yard details",
    required: true,
  },

  {
    id: "reference1Name",
    label: "Reference 1 Name",
    placeholder: "Enter reference 1 name",
    required: true,
  },
  {
    id: "reference1Phone",
    label: "Reference 1 Contact Number",
    placeholder: "Enter reference 1 contact number",
    required: true,
  },
  {
    id: "reference2Name",
    label: "Reference 2 Name",
    placeholder: "Enter reference 2 name",
    required: true,
  },
  {
    id: "reference2Phone",
    label: "Reference 2 Contact Number",
    placeholder: "Enter reference 2 contact number",
    required: true,
  },

  {
    id: "associatedFinanciers",
    label: "Associated Financiers",
    placeholder: "Enter associated financiers",
    required: false,
  },
  {
    id: "brokerBackground",
    label: "Broker Background",
    placeholder: "Describe broker background",
  },
];

export const partnerFields = [
  {
    id: "personName",
    label: "Person Name",
    placeholder: "Enter contact name",
    required: true,
  },
  {
    id: "phone",
    label: "Person Number",
    placeholder: "Enter contact number",
    required: true,
    type: "text",
    inputMode: "numeric",
    pattern: "[0-9]{10}",
    maxLength: 10,
  },
  {
    id: "email",
    label: "Mail Id",
    placeholder: "Enter email address",
    required: true,
  },
  {
    id: "businessExperienceYears",
    label: "Total Business Experience",
    placeholder: "Enter business experience (in years)",
    type: "number",
    required: true,
  },
  {
    id: "maritalStatusOfApplicant",
    label: "Marital Status of Applicant",
    type: "select",
    options: ["Single", "Married", "Divorced", "Widowed"],
    placeholder: "Select marital status",
    required: true,
  },
  {
    id: "residenceType",
    label: "Residence Type",
    type: "radio",
    options: ["Owned", "Rented"],
    placeholder: "Select residence type",
    required: true,
  },
];

export const selectDocList = [
  {
    header: "Select All",
    dataKey: "all",
  },
  {
    header: "DPN Documents",
    dataKey: "dpn_doc",
  },

  {
    header: "MT UDC Documents",
    dataKey: "mt_udc_doc",
  },
  {
    header: "TF UDC Doc",
    dataKey: "tf_udc_doc",
  },
  {
    header: "GST Declaration",
    dataKey: "gst_declaration",
  },
  {
    header: "DOB Declaration",
    dataKey: "dob_declaration",
  },
  {
    header: "Name Declaration",
    dataKey: "name_declaration",
  },
  {
    header: "Partners Authorization Letter",
    dataKey: "partners_authorization_letter",
  },
  {
    header: "Other Doc",
    dataKey: "other_doc",
  },
  {
    header: "Aadhar Consent",
    dataKey: "aadhar_consent",
  },
  {
    header: "Aadhar Consent & MT BL Agreement",
    dataKey: "mt_bl_agreement",
  },
  {
    header: "Signature Verification",
    dataKey: "signature_verification",
  },
  {
    header: "CRIF Report",
    dataKey: "crif_report",
  },
  {
    header: "Aadhar Card Front",
    dataKey: "aadhar_front",
    required: true,
  },

  {
    header: "Aadhar Card Back",
    dataKey: "aadhar_back",
    required: true,
  },
  {
    header: "Pan Card",
    dataKey: "pan",
    required: false,
  },
  {
    header: "Firm Pan Card",
    dataKey: "firm_pan",
  },
  {
    header: "Passport Size Photo",
    dataKey: "passport_photo",
    required: true,
  },
  {
    header: "Business Proof1",
    dataKey: "business_proof_1",
    type: "select",
    options: ["GST", "Udyam", "Shop Act"],
    required: true,
  },
  {
    header: "Business Proof2",
    dataKey: "business_proof_2",
    type: "select",
    options: ["GST", "Udyam", "Shop Act"],
    required: false,
  },
  {
    header: "Bank Statement",
    dataKey: "bank_statement",
    required: true,
  },

  {
    header: "KSOS Cheque 1",
    dataKey: "ksos_cheque_1",
    required: true,
  },
  {
    header: "KSOS Cheque 2",
    dataKey: "ksos_cheque_2",
    required: true,
  },
  {
    header: "Tyger Cheque 1",
    dataKey: "tyger_cheque_1",
    required: true,
  },
  {
    header: "Tyger Cheque 2",
    dataKey: "tyger_cheque_2",
    required: true,
  },
  {
    header: "Partnership Deed",
    dataKey: "partnership_deed",
    required: false,
  },
  {
    header: "ITR 1",
    dataKey: "itr_year_1",
    options: ["Yes", "No"],
    required: false,
  },
  {
    header: "ITR 2",
    dataKey: "itr_year_2",
    options: ["Yes", "No"],
    required: false,
  },
];

export const docheader = [
  {
    header: "Aadhar Card Front",
    dataKey: "aadhar_front",
    required: true,
  },

  {
    header: "Aadhar Card Back",
    dataKey: "aadhar_back",
    required: true,
  },
  {
    header: "Pan Card",
    dataKey: "pan",
    required: false,
  },
  {
    header: "Firm Pan Card",
    dataKey: "firm_pan",
  },
  {
    header: "Passport Size Photo",
    dataKey: "passport_photo",
    required: true,
  },
  {
    header: "Business Proof1",
    dataKey: "business_proof_1",
    type: "select",
    options: ["GST", "Udyam", "Shop Act"],
    required: true,
  },
  {
    header: "Business Proof2",
    dataKey: "business_proof_2",
    type: "select",
    options: ["GST", "Udyam", "Shop Act"],
    required: false,
  },
  {
    header: "Bank Statement",
    dataKey: "bank_statement",
    required: true,
  },

  {
    header: "KSOS Cheque 1",
    dataKey: "ksos_cheque_1",
    required: true,
  },
  {
    header: "KSOS Cheque 2",
    dataKey: "ksos_cheque_2",
    required: true,
  },
  {
    header: "Tyger Cheque 1",
    dataKey: "tyger_cheque_1",
    required: true,
  },
  {
    header: "Tyger Cheque 2",
    dataKey: "tyger_cheque_2",
    required: true,
  },
  {
    header: "Partnership Deed",
    dataKey: "partnership_deed",
    required: false,
  },
  {
    header: "ITR 1",
    dataKey: "itr_year_1",
    options: ["Yes", "No"],
    required: false,
  },
  {
    header: "ITR 2",
    dataKey: "itr_year_2",
    options: ["Yes", "No"],
    required: false,
  },
];
// Aadhar Consent used to be uploaded inside the mt_bl_agreement file. Until a
// case has its own aadhar_consent upload, its mt_bl_agreement file is still the
// combined document and is labelled as such. `docs` is either keyed by document
// name or an array of { documentName, isUploaded }.
export const hasSeparateAadharConsent = (docs) => {
  const consent = Array.isArray(docs)
    ? docs.find((d) => d?.documentName === "aadhar_consent")
    : docs?.aadhar_consent;
  return Boolean(consent?.isUploaded);
};

export const mtblAgreementLabel = (docs) =>
  hasSeparateAadharConsent(docs)
    ? "MTBL Agreement"
    : "Aadhar Consent & MTBL Agreement";

// Header for a document list row; only mt_bl_agreement depends on the case.
export const documentHeaderLabel = (doc, docs) =>
  doc?.dataKey === "mt_bl_agreement" ? mtblAgreementLabel(docs) : doc?.header;

export const limitSettingDocumentsHeader = [
  {
    header: "DPN Documents",
    dataKey: "dpn_doc",
  },

  {
    header: "MT UDC Documents",
    dataKey: "mt_udc_doc",
  },
  {
    header: "TF UDC Doc",
    dataKey: "tf_udc_doc",
  },
  {
    header: "MT Application Form",
    dataKey: "mt_application_form",
  },
  {
    header: "MT Sanction Letter",
    dataKey: "mt_sanction_letter",
  },
  {
    header: "GST Declaration",
    dataKey: "gst_declaration",
  },
  {
    header: "DOB Declaration",
    dataKey: "dob_declaration",
  },
  {
    header: "Name Declaration",
    dataKey: "name_declaration",
  },
  {
    header: "Partners Authorization Letter",
    dataKey: "partners_authorization_letter",
  },
  {
    header: "Other Doc",
    dataKey: "other_doc",
  },
  {
    header: "Aadhar Consent",
    dataKey: "aadhar_consent",
  },
  {
    header: "Aadhar Consent & MT BL Agreement",
    dataKey: "mt_bl_agreement",
  },
  {
    header: "Signature Verification",
    dataKey: "signature_verification",
  },
  {
    header: "CRIF Report",
    dataKey: "crif_report",
  },
];
export const businessHeaderv = [
  {
    dataKey: "personName",
    header: "Name",
  },
  {
    dataKey: "phone",
    header: "Phone",
  },
  {
    dataKey: "email",
    header: "Email",
  },
  { dataKey: "maritalStatusOfApplicant", header: "Marital Status" },

  {
    dataKey: "residenceType",
    header: "Residence Type",
  },
  {
    dataKey: "businessExperienceYears",
    header: "Experience",
  },
];
